import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { ReactSession } from "../../../lib/secure_reactsession";
import { LayoutResearcher } from "../../themes/userq/Layouts/layout_researcher";
import {
    getResearcherTestResultData,
    getFirstClickResultData,
} from "../../../services/researcher_test_results";
import toast from "react-hot-toast";
import moment from "moment";
import { useRecoilState } from "recoil";
import { testResultAtomFamily, testProjectAtomFamily } from "../../../store/testResultAtoms";
import { LoadingIcon } from "../../loader/loadingIcon";
import { TestResultsHeader } from "../../themes/userq/TestResultsHeader/TestResultsHeader";
import { TestResultsSidebarNavigation } from "./components/test_results_sidebar_navigation";
import { Icon } from "../../themes/userq/Icon/Icon";
import { Text } from "../../themes/userq/Text/Text";
import { PrototypeDropdown } from "../../themes/userq/QuestionsDropdown/PrototypeDropdown";
import { RadioButton } from "../../themes/userq/RadioButton/RadioButton";
import { DropdownComponent } from "../../themes/userq/Dropdown/Dropdown";
import h337 from "heatmap.js";
import QuestionAnswerfirstclickFollowResult from "./QuestionAnswerfirstclickFollowResult";
import { Button } from "../../themes/userq/Button/Button";
import { Helmet } from "react-helmet";
import { getPageTitle } from "../../../lib/pageTitle";

export default function TestResultFirstClick({ isSharedLink }) {
    const { test_id } = useParams();
    const navigate = useNavigate();
    const location = useLocation();

    const exportImageRef = useRef();
    const exportHeatmapRef = useRef();
    const exportClickmapRef = useRef();
    const heatmapCanvasRef = useRef();
    const clickmapCanvasRef = useRef();

    const imageHeatmapRef = useRef();
    const imageClickmapRef = useRef();

    const [isLoading, setLoading] = useState(false);
    const [sectionLoading, setSectionLoading] = useState(false);
    const [test, setTest] = useRecoilState(testResultAtomFamily(test_id));
    const [taskArray, setTaskArray] = useState([]);
    const [prototypeDataArray, setPrototypeDataArray] = useState([]);
    const [activePrototypeDataArray, setActivePrototypeDataArray] = useState("");
    const [taskSetting, setTaskSetting] = useState("");
    const [isActiveTask, setActiveTask] = useState(0);
    const [behaviorType, setBehaviorType] = useState("image");
    const [activeScreenOption, setActiveScreenOption] = useState("");

    const [activeScreenWidth, setActiveScreenWidth] = useState(1000);
    const [activeScreenHeight, setActiveScreenHeight] = useState(1000);

    const [screenSizes] = useState([
        {
            value: "Fit to width",
            label: "Fit to width",
        },
        {
            value: "Actual size",
            label: "Actual size",
        },
        {
            value: "Fit to canvas",
            label: "Fit to canvas",
        },
    ]);
    const [activeScreenSize, setActiveScreenSize] = useState("Fit to width");

    const [heatmapImageLoading, setHeatmapImageLoading] = useState(false);
    const canvasDrawingRef = useRef(false);
    const [downloadImageLoading, setDownloadImageLoading] = useState(false);

    const [resultCount, SetResultCount] = useState(0);
    const [dropdownOpen, setDropdownOpen] = useState(false);

    const [project, setProject] = useRecoilState(testProjectAtomFamily(test_id));

    const getTestafterEndTest = () => {
        let token = ReactSession.get("token");

        let guest_result_token = "";

        if (location.pathname.substr(1, 1) === "v") {
            if (!ReactSession.get("guest_result_token")) {
                const randomToken = Math.random().toString(36).substr(2, 15);
                ReactSession.set("guest_result_token", randomToken);
            }

            guest_result_token = ReactSession.get("guest_result_token");
        }
        let admin_result_token = "";

        if (location.pathname.substr(1, 1) === "a") {
            if (!ReactSession.get("admin_result_token")) {
                const randomToken = Math.random().toString(36).substr(2, 15);
                ReactSession.set("admin_result_token", randomToken);
            }

            admin_result_token = ReactSession.get("admin_result_token");
        }

        getResearcherTestResultData(
            {
                test_id: test_id,
                guest_result_token: guest_result_token,
                admin_result_token: admin_result_token,
            },
            token
        ).then((response) => {
            setLoading(false);

            if (response.success) {
                setTest(response.test);
            } else {
                navigate("/dashboard");
                toast(
                    <div className="toastinner">
                        {response.message}
                        <a
                            onClick={() => {
                                toast.dismiss();
                            }}
                        >
                            &times;
                        </a>
                    </div>,
                    {
                        className: response.success ? "successtoast" : "errortoast",
                        position: "bottom-center",
                        duration: 2000,
                    }
                );
            }
        });
    };

    const getTest = () => {
        if (!test) {
            let token = ReactSession.get("token");

            setLoading(true);

            let guest_result_token = "";
            if (location.pathname.substr(1, 1) === "v") {
                if (!ReactSession.get("guest_result_token")) {
                    const randomToken = Math.random().toString(36).substr(2, 15);
                    ReactSession.set("guest_result_token", randomToken);
                }

                guest_result_token = ReactSession.get("guest_result_token");
            }
            let admin_result_token = "";
            if (location.pathname.substr(1, 1) === "a") {
                if (!ReactSession.get("admin_result_token")) {
                    const randomToken = Math.random().toString(36).substr(2, 15);
                    ReactSession.set("admin_result_token", randomToken);
                }

                admin_result_token = ReactSession.get("admin_result_token");
            }

            getResearcherTestResultData(
                {
                    test_id: test_id,
                    guest_result_token: guest_result_token,
                    admin_result_token: admin_result_token,
                },
                token
            ).then((response) => {
                setLoading(false);

                if (response.success) {
                    if (response.workspace_project_team_member) {
                        if (response.workspace_project_team_member.status !== "active") {
                            navigate(
                                "/wsp/" +
                                response.workspace_project_team_member.workspace_id +
                                "/p/" +
                                response.workspace_project_team_member.workspace_project_id +
                                "/project-no-access"
                            );
                        }
                    }
                    if (response.test && response.test.workspace_project) {
                        setProject(response.test.workspace_project);
                    }
                    if (
                        location.pathname.substr(1, 1) === "v" &&
                        response.is_share_result
                    ) {
                        navigate(`/v/results/${test_id}/results-not-available`);
                    }

                    if (
                        location.pathname.substr(1, 1) === "v" &&
                        response.test.password &&
                        !response.test_password_verify
                    ) {
                        navigate(`/v/results/${test_id}/password`);
                    }

                    setTest(response.test);
                    getPrototypeTest();
                } else {
                    if (response.message === "Project not found.") {
                        navigate("/404");
                    } else if (response.message === "Test Record Not found") {
                        navigate("/404");
                    } else {
                        if (location.pathname.substr(1, 1) === "v") {
                            if (
                                response.test_shared_results &&
                                !response.test_password_verify
                            ) {
                                return navigate(`/v/results/${test_id}/password`);
                            } else if (!response.test_shared_results) {
                                return navigate(`/v/results/${test_id}/results-not-available`);
                            }
                        }
                        if (location.pathname.substr(1, 1) === "a") {
                            if (!response.test_results_available) {
                                return navigate(`/v/results/${test_id}/results-not-available`);
                            }
                        }
                        toast(
                            <div className="toastinner">
                                {response.message}
                                <a
                                    onClick={() => {
                                        toast.dismiss();
                                    }}
                                >
                                    &times;
                                </a>
                            </div>,
                            {
                                className: response.success ? "successtoast" : "errortoast",
                                position: "bottom-center",
                                duration: 2000,
                            }
                        );
                    }
                }
            });
        } else {
            getPrototypeTest();
        }
    };

    const getPrototypeTest = () => {
        let token = ReactSession.get("token");

        setSectionLoading(true);

        let guest_result_token = "";
        if (location.pathname.substr(1, 1) === "v") {
            guest_result_token = ReactSession.get("guest_result_token");
        }
        let admin_result_token = "";
        if (location.pathname.substr(1, 1) === "a") {
            admin_result_token = ReactSession.get("admin_result_token");
        }

        getFirstClickResultData(
            {
                test_id: test_id,
                guest_result_token: guest_result_token,
                admin_result_token: admin_result_token,
            },
            token
        ).then((response) => {
            setSectionLoading(false);

            if (response.success) {
                var firstClickTask = [];
                response.test.firstclick_test_tasks.forEach((items) => {
                    firstClickTask.push({
                        id: items.id,
                        description: items.description,
                        results_data: items.results_data,
                    });
                });
                setTaskArray(firstClickTask);
                setTaskSetting({ objective: "closed" });
                setPrototypeDataArray(response.data);
                changeActiveTask(1, response.data);
                SetResultCount(response.resultcount);
            } else {
                toast(
                    <div className="toastinner">
                        {response.message}
                        <a
                            onClick={() => {
                                toast.dismiss();
                            }}
                        >
                            &times;
                        </a>
                    </div>,
                    {
                        className: response.success ? "successtoast" : "errortoast",
                        position: "bottom-center",
                        duration: 2000,
                    }
                );
            }
        });
    };

    useEffect(() => {
        getTest();
    }, [location]);

    const callbackTopbar = () => {
        getTest();
        getTestafterEndTest();
    };

    const changeActiveTask = (index, data) => {
        setActiveTask(index - 1);

        const dataAnswer = data.find((item, indexItem) => indexItem + 1 === index);
        if (dataAnswer) {
            setActivePrototypeDataArray(dataAnswer);
            setBehaviorType("image");

            var screenOptionArray = [];
            dataAnswer.behaviourData.forEach((items) => {
                screenOptionArray.push({
                    label: items.name,
                    value: items.node_id,
                    img: items.img,
                });
            });

            setActiveScreenOption(screenOptionArray[0].value);
        }
    };

    useEffect(() => {
        if (behaviorType !== "image") {
            canvasDrawingRef.current = true;
            setHeatmapImageLoading(true);
        }

        const timeoutId = setTimeout(() => {
            requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    HeatmapCalculations(activePrototypeDataArray.behaviourData);
                });
            });
        }, 200);

        return () => clearTimeout(timeoutId);
    }, [activeScreenOption, behaviorType, activeScreenSize]);

    const HeatmapCalculations = (dataItems) => {
        document.querySelectorAll(".heatmap-canvas").forEach((el) => el.remove());
        if (behaviorType === "image") {
            canvasDrawingRef.current = false;
            setHeatmapImageLoading(false);
            return;
        }
        var scaleX = 1;
        var scaleY = 1;
        if (behaviorType === "heatmap" && imageHeatmapRef.current) {
            void imageHeatmapRef.current.offsetHeight;
        } else if (behaviorType === "clickmap" && imageClickmapRef.current) {
            void imageClickmapRef.current.offsetHeight;
        }

        if (behaviorType === "heatmap") {
            setActiveScreenWidth(imageHeatmapRef.current.clientWidth);
            setActiveScreenHeight(imageHeatmapRef.current.clientHeight);
            if (imageHeatmapRef.current.naturalWidth > 0) {
                scaleX =
                    imageHeatmapRef.current.clientWidth /
                    imageHeatmapRef.current.naturalWidth;
                scaleY =
                    imageHeatmapRef.current.clientHeight /
                    imageHeatmapRef.current.naturalHeight;
            }
        } else if (behaviorType === "clickmap") {
            setActiveScreenWidth(imageClickmapRef.current.clientWidth);
            setActiveScreenHeight(imageClickmapRef.current.clientHeight);
            if (imageClickmapRef.current.naturalWidth > 0) {
                scaleX =
                    imageClickmapRef.current.clientWidth /
                    imageClickmapRef.current.naturalWidth;
                scaleY =
                    imageClickmapRef.current.clientHeight /
                    imageClickmapRef.current.naturalHeight;
            }
        }

        if (behaviorType === "heatmap") {
            var heatmapInstance = h337.create({
                container: document.querySelector(".heatmapImage"),
                width: imageHeatmapRef.current.clientWidth,
                height: imageHeatmapRef.current.clientHeight,
                gradient: {
                    ".5": "#9759CB",
                    ".8": "#FFB800",
                    ".9": "#e6542a",
                },
            });

            var points = [];
            var max = 0;
            dataItems.forEach((items) => {
                if (items.node_id === activeScreenOption) {
                    items.heatMapDataArray.forEach((heat) => {
                        var point = {
                            x: Math.round(heat.x * scaleX),
                            y: Math.round(heat.y * scaleY),
                            value: heat.value,
                        };
                        points.push(point);
                    });
                }
            });
            var data = {
                max: max,
                data: points,
            };
            heatmapInstance.setData(data);
        }

        if (behaviorType === "clickmap") {
            var clickmapInstance = h337.create({
                container: document.querySelector(".clickMapImage"),
                radius: 5,
                maxOpacity: 1,
                minOpacity: 0,
                blur: 0,
                width: imageClickmapRef.current.clientWidth,
                height: imageClickmapRef.current.clientHeight,
                gradient: {
                    ".95": "#E32F83",
                },
            });

            const clickPoints = [];
            let clickMax = 0;

            dataItems.forEach((items) => {
                if (items.node_id === activeScreenOption) {
                    items.heatMapDataArray.forEach((heat) => {
                        const point = {
                            x: Math.round(heat.x * scaleX),
                            y: Math.round(heat.y * scaleY),
                            value: heat.value,
                        };
                        clickPoints.push(point);
                    });
                }
            });

            const clickMapPayload = {
                max: clickMax,
                data: clickPoints,
            };
            clickmapInstance.setData(clickMapPayload);
        }

        if (behaviorType === "heatmap") {
            canvasDrawingRef.current = true;
            setHeatmapImageLoading(true);
            convertImageToBase64(
                process.env.REACT_APP_API_END_POINT +
                "prototype-test-node-image?image=" +
                imageHeatmapRef.current.src,
                function (data) {
                    const imgs = [
                        {
                            uri: data,
                            x: 0,
                            y: 0,
                            sw: imageHeatmapRef.current.clientWidth,
                            sh: imageHeatmapRef.current.clientHeight,
                            type: "image",
                        },
                        {
                            uri: heatmapInstance.getDataURL(),
                            x: 0,
                            y: 0,
                            sw: imageHeatmapRef.current.clientWidth,
                            sh: imageHeatmapRef.current.clientHeight,
                            type: "heatmap",
                        },
                    ];

                    setTimeout(() => {
                        Promise.all(imgs.map(depictHeatmap)).then(() => {
                            canvasDrawingRef.current = false;
                            setHeatmapImageLoading(false);
                        });
                    }, 100);

                    const scrollElem = document.getElementById("heatmap-canvas-wrapper");
                    if (scrollElem) {
                        scrollElem.scrollIntoView({
                            behavior: "smooth",
                            block: "start",
                        });
                    }
                }
            );
        }

        if (behaviorType === "clickmap") {
            canvasDrawingRef.current = true;
            setHeatmapImageLoading(true);
            convertImageToBase64(
                process.env.REACT_APP_API_END_POINT +
                "prototype-test-node-image?image=" +
                imageClickmapRef.current.src,
                function (data) {
                    const imgs = [
                        {
                            uri: data,
                            x: 0,
                            y: 0,
                            sw: imageClickmapRef.current.clientWidth,
                            sh: imageClickmapRef.current.clientHeight,
                            type: "image",
                        },
                        {
                            uri: clickmapInstance.getDataURL(),
                            x: 0,
                            y: 0,
                            sw: imageClickmapRef.current.clientWidth,
                            sh: imageClickmapRef.current.clientHeight,
                            type: "heatmap",
                        },
                    ];

                    setTimeout(() => {
                        Promise.all(imgs.map(depictClickmap)).then(() => {
                            canvasDrawingRef.current = false;
                            setHeatmapImageLoading(false);
                        });
                    }, 100);

                    const scrollElem = document.getElementById("clickmap-canvas-wrapper");
                    if (scrollElem) {
                        scrollElem.scrollIntoView({
                            behavior: "smooth",
                            block: "start",
                        });
                    }
                }
            );
        }
    };

    const getHeatmapContext = () => {
        const canvas = document.getElementById("heatmap-canvas");
        if (!canvas) {
            console.error("Canvas element #heatmap-canvas not found");
            return null;
        }
        return canvas.getContext("2d");
    };

    const getClickmapContext = () => {
        const canvas = document.getElementById("clickmap-canvas");
        if (!canvas) {
            console.error("Canvas element #clickmap-canvas not found");
            return null;
        }
        return canvas.getContext("2d");
    };

    const loadImage = (url, type) => {
        return new Promise((resolve, reject) => {
            const img = new Image();
            img.onload = () => resolve(img);
            img.onerror = () => reject(new Error(`load ${url} ${type} fail`));
            img.src = url;
        });
    };

    const depictHeatmap = (options) => {
        const ctx = getHeatmapContext();
        if (!ctx) {
            return;
        }
        const myOptions = Object.assign({}, options);
        return loadImage(myOptions.uri, myOptions.type).then((img) => {
            ctx.drawImage(img, myOptions.x, myOptions.y, myOptions.sw, myOptions.sh);
        });
    };

    const depictClickmap = (options) => {
        const ctx = getClickmapContext();
        if (!ctx) {
            return;
        }
        const myOptions = Object.assign({}, options);
        return loadImage(myOptions.uri, myOptions.type).then((img) => {
            ctx.drawImage(img, myOptions.x, myOptions.y, myOptions.sw, myOptions.sh);
        });
    };

    const convertImageToBase64 = (imgUrl, callback) => {
        const image = new Image();
        image.crossOrigin = "anonymous";
        image.onload = () => {
            const canvas = document.createElement("canvas");
            const ctx = canvas.getContext("2d");
            canvas.height = image.naturalHeight;
            canvas.width = image.naturalWidth;
            ctx.drawImage(image, 0, 0);
            const dataUrl = canvas.toDataURL();
            callback && callback(dataUrl);
        };
        image.src = imgUrl;
    };

    const averageTaskTime = (timeSpend) => {
        var averageTimeSpendMinute = Math.floor(timeSpend / (resultCount * 60));
        var averageTimeSpendSeconds = ((timeSpend / resultCount) % 60).toFixed(0);

        if (averageTimeSpendSeconds.length === 1) {
            return averageTimeSpendMinute + "m 0" + averageTimeSpendSeconds + "s";
        }
        return averageTimeSpendMinute + "m " + averageTimeSpendSeconds + "s";
    };

    const handleDownload = async () => {
        setDownloadImageLoading(true);

        try {
            const canvasId =
                behaviorType === "heatmap" ? "heatmap-canvas" : "clickmap-canvas";

            if (canvasDrawingRef.current) {
                await new Promise((resolve, reject) => {
                    const maxWait = 10000;
                    const interval = 100;
                    let waited = 0;
                    const timer = setInterval(() => {
                        waited += interval;
                        if (!canvasDrawingRef.current) {
                            clearInterval(timer);
                            resolve();
                        } else if (waited >= maxWait) {
                            clearInterval(timer);
                            reject(new Error("Canvas draw timed out"));
                        }
                    }, interval);
                });
            }

            const canvas = document.getElementById(canvasId);

            if (!canvas) {
                console.error("Canvas not found:", canvasId);
                setDownloadImageLoading(false);
                return;
            }

            const filename =
                behaviorType === "heatmap" ? "heatmap.png" : "clickmap.png";

            if (canvas.toBlob) {
                canvas.toBlob((blob) => {
                    if (!blob) {
                        console.error("Canvas export returned empty blob");
                        setDownloadImageLoading(false);
                        return;
                    }
                    const url = URL.createObjectURL(blob);
                    const link = document.createElement("a");
                    link.download = filename;
                    link.href = url;
                    link.click();
                    URL.revokeObjectURL(url);
                    setDownloadImageLoading(false);
                }, "image/png");
            } else {
                const link = document.createElement("a");
                link.download = filename;
                link.href = canvas.toDataURL("image/png");
                link.click();
                setDownloadImageLoading(false);
            }
        } catch (error) {
            console.error("Error downloading image:", error);
            setDownloadImageLoading(false);
        }
    };

    function Position(obj) {
        var currenttop = 0;
        if (obj.offsetParent) {
            do {
                currenttop += obj.offsetTop;
            } while ((obj = obj.offsetParent));
            return [currenttop];
        }
    }
    const scrollto = (area) => {
        var fixedElementHeight =
            document.querySelector(".researcher-header").offsetHeight +
            document.querySelector(".test-results-header-researcher").offsetHeight;
        var offsetTop = Position(document.getElementById(area));
        window.scrollTo({
            top: offsetTop - fixedElementHeight + 0,
            behavior: "smooth",
        });
    };

    return (
        <LayoutResearcher
            isSharedLink={isSharedLink}
            fixed_header_target={true}
            wrapClass={
                "researcher-test-view-overflow overflow-visible researcher-resultwrap"
            }
            resultHeaderClass={"result-header"}
            skipCheck={false}
            extendedFooter={false}
            activeMenu={""}
        >
            <Helmet>
                <title>{getPageTitle("Analyse first click")}</title>
            </Helmet>
            {isLoading && (
                <div className="loader_section full-page-loader">
                    <LoadingIcon />
                </div>
            )}

            {!isLoading && test && (
                <div className="three-column-layout two-column-layout">
                    <TestResultsHeader
                        project={project}
                        isSharedLink={isSharedLink}
                        test={test}
                        endedOn={
                            test.status === "completed"
                                ? moment.utc(test.ended_on).format("DD-MM-Y")
                                : ""
                        }
                        callbackTopbar={callbackTopbar}
                    />
                    <div className="three-column-layout-body">
                        <div className="three-column-layout-left">
                            <TestResultsSidebarNavigation
                                isSharedLink={isSharedLink}
                                methodology={
                                    test.methodology === "Five Seconds Test"
                                        ? "5 second test"
                                        : test.methodology
                                }
                                selected_index={4}
                                test_id={
                                    location.pathname.substr(1, 1) === "v" ? test_id : test.id
                                }
                                screening={
                                    test &&
                                        test.screening_questions &&
                                        test.screening_questions.length > 0
                                        ? "Yes"
                                        : "No"
                                }
                            />
                        </div>
                        <div className="two-column-right-side">
                            {sectionLoading && (
                                <div className="page-loader accountloading-box result-sections-loader">
                                    <LoadingIcon />
                                </div>
                            )}
                            {!sectionLoading && resultCount !== 0 && (
                                <div className="bd-question-view-wrap">
                                    <div
                                        className={`question-result-data  ${dropdownOpen ? "black-overlay" : ""
                                            }`}
                                    >
                                        <div className="question-result-header">
                                            <PrototypeDropdown
                                                questionArray={taskArray}
                                                changeActiveQuestionProp={(index) => {
                                                    changeActiveTask(index, prototypeDataArray);
                                                    scrollto("overview");
                                                }}
                                                dropdownOpen={(state) => setDropdownOpen(state)}
                                                resultCount={resultCount}
                                                taskSetting={taskSetting && taskSetting.objective}
                                                test={test}
                                            />
                                        </div>

                                        <div className="prototype-result-overview-wrap">
                                            <div className={`prototype-behavior`}>
                                                <div className={`behavior-header`} id="overview">
                                                    <Text type={"h4"} children={"Behaviour"} />
                                                </div>

                                                <div id={"behavior"}></div>
                                                <div className={`prototype-behavior-content mt-40`}>
                                                    <div
                                                        className={`behavior-content-top d-flex justify-content-between mb-5`}
                                                    >
                                                        <div className={`behavior-top-left-content d-flex`}>
                                                            <RadioButton
                                                                id="open_image_toggle"
                                                                isChecked={
                                                                    behaviorType === "image" ? true : false
                                                                }
                                                                label={
                                                                    <Text
                                                                        display="inline"
                                                                        type="body-text-2"
                                                                        fontWeight={"medium-font"}
                                                                        cssClasses={
                                                                            "d-flex align-items-center radio-tab-icon"
                                                                        }
                                                                    >
                                                                        <Icon
                                                                            value={"image"}
                                                                            colorClass={"gray-700-svg"}
                                                                        />{" "}
                                                                        Image
                                                                    </Text>
                                                                }
                                                                onChange={(e) => {
                                                                    setBehaviorType(e.target.value);
                                                                }}
                                                                value={"image"}
                                                            />

                                                            <RadioButton
                                                                id="open_heatmap_toggle"
                                                                isChecked={
                                                                    behaviorType === "heatmap" ? true : false
                                                                }
                                                                label={
                                                                    <Text
                                                                        display="inline"
                                                                        type="body-text-2"
                                                                        fontWeight={"medium-font"}
                                                                        cssClasses={
                                                                            "d-flex align-items-center radio-tab-icon"
                                                                        }
                                                                    >
                                                                        <Icon
                                                                            value={"Heatmap"}
                                                                            colorClass={"gray-700-svg"}
                                                                        />{" "}
                                                                        Heatmap
                                                                    </Text>
                                                                }
                                                                onChange={(e) => {
                                                                    setBehaviorType(e.target.value);
                                                                }}
                                                                value={"heatmap"}
                                                            />

                                                            <RadioButton
                                                                id="open_clickmap_toggle"
                                                                isChecked={
                                                                    behaviorType === "clickmap" ? true : false
                                                                }
                                                                label={
                                                                    <Text
                                                                        display="inline"
                                                                        type="body-text-2"
                                                                        fontWeight={"medium-font"}
                                                                        cssClasses={
                                                                            "d-flex align-items-center radio-tab-icon"
                                                                        }
                                                                    >
                                                                        <Icon
                                                                            value={"click"}
                                                                            colorClass={"gray-700-svg"}
                                                                        />{" "}
                                                                        Clickmap
                                                                    </Text>
                                                                }
                                                                onChange={(e) => {
                                                                    setBehaviorType(e.target.value);
                                                                }}
                                                                value={"clickmap"}
                                                            />
                                                        </div>

                                                        <div
                                                            className={`behavior-top-right-content d-flex`}
                                                        >
                                                            <div
                                                                className={`prototype-behavior-screen-size-content`}
                                                            >
                                                                <DropdownComponent
                                                                    name="screenSize"
                                                                    label="Select size"
                                                                    onChange={(data) => {
                                                                        setActiveScreenSize(data.value);
                                                                    }}
                                                                    options={screenSizes}
                                                                    value={activeScreenSize}
                                                                    isClearable={false}
                                                                />
                                                            </div>

                                                            {behaviorType !== "image" && (
                                                                <Button
                                                                    size={"medium"}
                                                                    type={"secondary"}
                                                                    iconLeft={<Icon value={"download"} />}
                                                                    label={"Download Image"}
                                                                    state={
                                                                        downloadImageLoading ? "disabled" : "active"
                                                                    }
                                                                    onClick={(e) => {
                                                                        if (!downloadImageLoading) {
                                                                            handleDownload();
                                                                        }
                                                                    }}
                                                                />
                                                            )}
                                                        </div>
                                                    </div>

                                                    <div
                                                        className={`behavior-main-slider-content-none  dropdown-header-arrow-buttons ${behaviorType === "image"
                                                            ? ""
                                                            : `heatmap-clickmap-data-none ${activeScreenSize === "Actual size"
                                                                ? "prototype-map-slider-wrap firstclick-slider-wrap"
                                                                : ""
                                                            }`
                                                            }`}
                                                    >
                                                        {activePrototypeDataArray.behaviourData &&
                                                            activePrototypeDataArray.behaviourData.map(
                                                                (items, index) => {
                                                                    return (
                                                                        <React.Fragment
                                                                            key={`${items.node_id || "node"
                                                                                }-behavior-${index}`}
                                                                        >
                                                                            {items.node_id === activeScreenOption && (
                                                                                <>
                                                                                    <div className="w-100 firstclick-center">
                                                                                        <div
                                                                                            ref={exportImageRef}
                                                                                            className={`${behaviorType === "image"
                                                                                                ? "w-100 text-center"
                                                                                                : "d-none"
                                                                                                }`}
                                                                                            style={{
                                                                                                overflowX:
                                                                                                    activeScreenSize ===
                                                                                                        "Actual size"
                                                                                                        ? "auto"
                                                                                                        : "hidden",
                                                                                            }}
                                                                                        >
                                                                                            <img
                                                                                                alt=""
                                                                                                src={
                                                                                                    items.img &&
                                                                                                        !items.img.includes("https")
                                                                                                        ? `${process.env.REACT_APP_IMG_URL.replace(
                                                                                                            /\/$/,
                                                                                                            ""
                                                                                                        )}/${items.img.replace(
                                                                                                            /^\//,
                                                                                                            ""
                                                                                                        )}`
                                                                                                        : items.img
                                                                                                }
                                                                                                style={{
                                                                                                    maxWidth:
                                                                                                        activeScreenSize ===
                                                                                                            "Actual size"
                                                                                                            ? "none"
                                                                                                            : "100%",
                                                                                                    display: "table",
                                                                                                    margin: "0 auto",
                                                                                                    maxHeight:
                                                                                                        activeScreenSize ===
                                                                                                            "Fit to canvas"
                                                                                                            ? "600px"
                                                                                                            : "unset",
                                                                                                }}
                                                                                            />
                                                                                        </div>
                                                                                        <div className="w-100 flex-center">
                                                                                            <div
                                                                                                ref={exportHeatmapRef}
                                                                                                className={`heatmapImage ${behaviorType === "heatmap"
                                                                                                    ? ""
                                                                                                    : "d-none"
                                                                                                    }`}
                                                                                                style={{
                                                                                                    width:
                                                                                                        activeScreenSize ===
                                                                                                            "Fit to width"
                                                                                                            ? ""
                                                                                                            : activeScreenWidth
                                                                                                                ? activeScreenWidth + "px"
                                                                                                                : "100%",
                                                                                                    height:
                                                                                                        activeScreenSize ===
                                                                                                            "Fit to width"
                                                                                                            ? "auto"
                                                                                                            : activeScreenHeight
                                                                                                                ? activeScreenHeight +
                                                                                                                "px"
                                                                                                                : "auto",
                                                                                                    overflowX:
                                                                                                        activeScreenSize ===
                                                                                                            "Actual size"
                                                                                                            ? "auto"
                                                                                                            : "hidden",
                                                                                                    overflowY: "hidden",
                                                                                                }}
                                                                                            >
                                                                                                <img
                                                                                                    alt=""
                                                                                                    ref={imageHeatmapRef}
                                                                                                    id="imageid"
                                                                                                    src={
                                                                                                        items.img &&
                                                                                                            !items.img.includes("https")
                                                                                                            ? `${process.env.REACT_APP_IMG_URL.replace(
                                                                                                                /\/$/,
                                                                                                                ""
                                                                                                            )}/${items.img.replace(
                                                                                                                /^\//,
                                                                                                                ""
                                                                                                            )}`
                                                                                                            : items.img
                                                                                                    }
                                                                                                    style={{
                                                                                                        maxWidth:
                                                                                                            activeScreenSize ===
                                                                                                                "Actual size"
                                                                                                                ? "unset"
                                                                                                                : "100%",
                                                                                                        display: "block",
                                                                                                        maxHeight:
                                                                                                            activeScreenSize ===
                                                                                                                "Fit to canvas"
                                                                                                                ? "600px"
                                                                                                                : "unset",
                                                                                                    }}
                                                                                                />
                                                                                            </div>
                                                                                        </div>

                                                                                        <div className="w-100 flex-center">
                                                                                            <div
                                                                                                ref={exportClickmapRef}
                                                                                                className={`clickMapImage position-relative ${behaviorType === "clickmap"
                                                                                                    ? ""
                                                                                                    : "d-none"
                                                                                                    }`}
                                                                                                style={{
                                                                                                    width:
                                                                                                        activeScreenSize ===
                                                                                                            "Fit to width"
                                                                                                            ? ""
                                                                                                            : activeScreenWidth
                                                                                                                ? activeScreenWidth + "px"
                                                                                                                : "100%",
                                                                                                    height:
                                                                                                        activeScreenSize ===
                                                                                                            "Fit to width"
                                                                                                            ? "auto"
                                                                                                            : activeScreenHeight
                                                                                                                ? activeScreenHeight +
                                                                                                                "px"
                                                                                                                : "auto",
                                                                                                    overflowX:
                                                                                                        activeScreenSize ===
                                                                                                            "Actual size"
                                                                                                            ? "auto"
                                                                                                            : "hidden",
                                                                                                    overflowY: "hidden",
                                                                                                }}
                                                                                            >
                                                                                                <img
                                                                                                    alt=""
                                                                                                    ref={imageClickmapRef}
                                                                                                    src={
                                                                                                        items.img &&
                                                                                                            !items.img.includes("https")
                                                                                                            ? `${process.env.REACT_APP_IMG_URL.replace(
                                                                                                                /\/$/,
                                                                                                                ""
                                                                                                            )}/${items.img.replace(
                                                                                                                /^\//,
                                                                                                                ""
                                                                                                            )}`
                                                                                                            : items.img
                                                                                                    }
                                                                                                    style={{
                                                                                                        maxWidth:
                                                                                                            activeScreenSize ===
                                                                                                                "Actual size"
                                                                                                                ? "unset"
                                                                                                                : "100%",
                                                                                                        display: "block",
                                                                                                        maxHeight:
                                                                                                            activeScreenSize ===
                                                                                                                "Fit to canvas"
                                                                                                                ? "600px"
                                                                                                                : "unset",
                                                                                                    }}
                                                                                                />
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>

                                                                                    {heatmapImageLoading &&
                                                                                        behaviorType !== "image" && (
                                                                                            <div className="page-loader accountloading-box result-sections-loader result-sections-loader-center">
                                                                                                <LoadingIcon />
                                                                                            </div>
                                                                                        )}

                                                                                    {behaviorType === "heatmap" && (
                                                                                        <div
                                                                                            className={`heatmap-canvas-wrapper map-absolute`}
                                                                                            id="heatmap-canvas-wrapper"
                                                                                            style={{
                                                                                                position: "absolute",
                                                                                                left: "-9999px",
                                                                                                top: "-9999px",
                                                                                                visibility: "hidden",
                                                                                            }}
                                                                                        >
                                                                                            <canvas
                                                                                                ref={heatmapCanvasRef}
                                                                                                id="heatmap-canvas"
                                                                                                style={{
                                                                                                    maxWidth:
                                                                                                        activeScreenSize ===
                                                                                                            "Actual size"
                                                                                                            ? "unset"
                                                                                                            : "100%",
                                                                                                    display: "table",
                                                                                                    margin: "0 auto",
                                                                                                    maxHeight:
                                                                                                        activeScreenSize ===
                                                                                                            "Fit to canvas"
                                                                                                            ? "600px"
                                                                                                            : "unset",
                                                                                                }}
                                                                                                width={
                                                                                                    activeScreenWidth
                                                                                                        ? activeScreenWidth
                                                                                                        : 0
                                                                                                }
                                                                                                height={
                                                                                                    activeScreenHeight
                                                                                                        ? activeScreenHeight
                                                                                                        : 0
                                                                                                }
                                                                                            ></canvas>
                                                                                        </div>
                                                                                    )}

                                                                                    {behaviorType === "clickmap" && (
                                                                                        <div
                                                                                            className={`clickmap-canvas-wrapper map-absolute`}
                                                                                            id="clickmap-canvas-wrapper"
                                                                                            style={{
                                                                                                position: "absolute",
                                                                                                left: "-9999px",
                                                                                                top: "-9999px",
                                                                                                visibility: "hidden",
                                                                                            }}
                                                                                        >
                                                                                            <canvas
                                                                                                ref={clickmapCanvasRef}
                                                                                                id="clickmap-canvas"
                                                                                                style={{
                                                                                                    maxWidth:
                                                                                                        activeScreenSize ===
                                                                                                            "Actual size"
                                                                                                            ? "unset"
                                                                                                            : "100%",
                                                                                                    display: "table",
                                                                                                    margin: "0 auto",
                                                                                                    maxHeight:
                                                                                                        activeScreenSize ===
                                                                                                            "Fit to canvas"
                                                                                                            ? "600px"
                                                                                                            : "unset",
                                                                                                }}
                                                                                                width={
                                                                                                    activeScreenWidth
                                                                                                        ? activeScreenWidth
                                                                                                        : 0
                                                                                                }
                                                                                                height={
                                                                                                    activeScreenHeight
                                                                                                        ? activeScreenHeight
                                                                                                        : 0
                                                                                                }
                                                                                            ></canvas>
                                                                                        </div>
                                                                                    )}
                                                                                </>
                                                                            )}
                                                                        </React.Fragment>
                                                                    );
                                                                }
                                                            )}
                                                    </div>

                                                    <div className="slider-time-bottom">
                                                        {activePrototypeDataArray.behaviourData &&
                                                            activePrototypeDataArray.behaviourData.map(
                                                                (items, index) => {
                                                                    return (
                                                                        <React.Fragment
                                                                            key={`${items.node_id || "node"
                                                                                }-time-${index}`}
                                                                        >
                                                                            {items.node_id === activeScreenOption && (
                                                                                <>
                                                                                    <div className="slide-count-info light-dark-text medium-font">
                                                                                        <Icon
                                                                                            size={"medium"}
                                                                                            value={"time"}
                                                                                        />
                                                                                        Average time spent
                                                                                        <span>
                                                                                            {averageTaskTime(
                                                                                                items.average_time
                                                                                            )}
                                                                                        </span>
                                                                                    </div>
                                                                                </>
                                                                            )}
                                                                        </React.Fragment>
                                                                    );
                                                                }
                                                            )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="prototype-followup-section">
                                        <Text cssClasses={"pt-5"} type={"h4"}>
                                            Follow up question
                                        </Text>
                                        {taskArray[isActiveTask] && (
                                            <>
                                                <QuestionAnswerfirstclickFollowResult
                                                    resultData={taskArray[isActiveTask]["results_data"]}
                                                    resultCount={resultCount}
                                                />
                                            </>
                                        )}
                                    </div>
                                </div>
                            )}

                            {!sectionLoading && resultCount === 0 && (
                                <div className={`no-participants-data no-questions-data`}>
                                    <div
                                        className="no-page-data-wrap"
                                        style={{ marginTop: "80px" }}
                                    >
                                        <div className="no-data-icon">
                                            <Icon
                                                vcolorClass={"gray-700-svg"}
                                                value={"attention"}
                                                size={"large"}
                                            />
                                        </div>

                                        <Text type={"subtitle-1"} fontWeight="medium-font">
                                            Details are not available at the moment as the test didn’t
                                            receive any response yet. Please come back later.
                                        </Text>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            )}
        </LayoutResearcher>
    );
}
